var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar"},[_c('span',{staticClass:"has-background-info has-text-white user-avatar__default"},[_c('span',{staticStyle:{"opacity":"0.8","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.name.toUpperCase().charAt(0))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }